// @flow
import {
  configureStore,
  ActionType,
  addBetFailure,
  addBetSuccess
} from "bb-betslip";
import loadStore from "./storeLoader";
import get from "lodash.get";
import { PricingError } from "../errors/pricingError";

/**
 * Action to listen to for OB betslip success
 *
 * @ignore
 * @type {string}
 */
const OB_SLIP_BLDR_SUCCESS = "ob.betslip.buildSlipSuccess";
/**
 * Action to listen to for OB betslip success
 *
 * @ignore
 * @type {string}
 */
const OB_SLIP_BLDR_FAILURE = "ob.betslip.buildSlipFailure";

/**
 * The global eventemitter object present in OpenBet environments.
 * Used to send and receive messages between these components and OB components
 *
 * @ignore
 */
const emitter = get(window, "__OpenbetEventBus__.emitter", null);

/**
 * Define the inbound and outbound messages to/from this components store
 *
 * @ignore
 * @type {{inbound: *[], outbound: *[]}}
 */
const config = {
  outbound: [
    ActionType.ADD_SELECTIONS_SUCCESS,
    ActionType.ADD_SELECTIONS_FAILURE,
    ActionType.REMOVE_SELECTIONS_SUCCESS,
    ActionType.REMOVE_SELECTIONS_FAILURE,
    ActionType.CLEAR_SELECTIONS,
    ActionType.ADD_BET_REQUEST,
    ActionType.ADD_BET_SUCCESS,
    ActionType.ADD_BET_FAILURE
  ],
  inbound: [
    ActionType.ADD_SELECTIONS_REQUEST,
    ActionType.REMOVE_SELECTIONS_REQUEST,
    ActionType.USER_INTERACTION_ENABLED,
    ActionType.FETCH_MARKETS_FAILURE
  ]
};

/**
 * Map the Betslips internal DS' to to the format expected by OB
 *
 * @ignore
 * @param outcomes
 * @param numerator
 * @param denominator
 * @returns {{outcomes: Array<{outcomeId: number}>, price: {type: string, numerator: *, denominator: *}, extra: {combinationRef: string}}}
 */
const mapToOBSlip = (outcomes, numerator, denominator) => {
  return {
    outcomes: Object.keys(outcomes).map(outcomeId => {
      let outcome = {
        outcomeId: parseInt(outcomeId, 10)
      };
      if (
        outcomes[outcomeId].prices != null &&
        outcomes[outcomeId].prices.length > 0
      ) {
        outcome.price = outcomes[outcomeId].prices[0];
      }
      return outcome;
    }),
    extra: { combinationRef: "BUILDER_BET" },
    price: {
      type: "LP",
      numerator,
      denominator
    }
  };
};

/**
 * Length of time to wait before abandoning adding to external betslip
 *
 * @ignore
 *
 * @type {number}
 */
const timeoutLength = 20000;

/**
 * Class Handler that manages the sending and receiving of Betslip events over the eventbus
 *
 * @ignore
 */
class AddToSlipHandler {
  emitter: any = null;
  api: any = null;
  timer: any = null;
  outcomes: any = null;
  priceObject: any = null;

  constructor(api) {
    this.api = api;
    this.emitter = get(window, "__OpenbetEventBus__.emitter", null);
  }

  _addListeners = emitter => {
    emitter.on(OB_SLIP_BLDR_SUCCESS, this.handleSuccess);
    emitter.on(OB_SLIP_BLDR_FAILURE, this.handleFailure);
  };

  _removeListeners = emitter => {
    emitter.off(OB_SLIP_BLDR_SUCCESS, this.handleSuccess);
    emitter.off(OB_SLIP_BLDR_FAILURE, this.handleFailure);
  };

  addToSlip = (outcomes, priceObject) => {
    if (emitter == null) {
      throw Error("No Event Emitter found on this Env.");
    }
    if (outcomes == null || outcomes.length === 0) {
      throw Error("No Outcomes to Add to slip.");
    }
    this.outcomes = outcomes;
    this.priceObject = priceObject;
    this._addListeners(emitter);

    const obEventPayload = mapToOBSlip(
      outcomes,
      priceObject.numerator,
      priceObject.denominator
    );
    this.emitter.emitAsync("ob.slip.addleg", obEventPayload, {
      eventName: "ob.slip.addleg"
    });

    this.timer = setTimeout(() => {
      this.api.dispatch(addBetFailure(PricingError.GENERIC, outcomes, priceObject));
      this._removeListeners(emitter);
    }, timeoutLength);
  };

  handleSuccess = () => {
    clearTimeout(this.timer);
    this.api.dispatch(addBetSuccess(this.outcomes, this.priceObject));
    this._removeListeners(emitter);
  };

  handleFailure = () => {
    clearTimeout(this.timer);
    this.api.dispatch(
      addBetFailure(PricingError.GENERIC, this.outcomes, this.priceObject)
    );
    this._removeListeners(emitter);
  };
}

/**
 * Intercepts requests to add the BuilderBet to the betslip and sends over the eventbus
 *
 * @ignore
 * @param api
 * @returns {function(*): Function}
 */
const addToSlipMiddleware = api => next => action => {
  if (action.type === ActionType.ADD_BET_REQUEST) {
    const handler = new AddToSlipHandler(api);
    handler.addToSlip(action.payload.outcomes, action.payload.priceObject);
  }
  next(action);
};

/**
 * Creates the betslip store
 *
 * @ignore
 */
const betslipStore = () =>
  loadStore(config, configureStore, [addToSlipMiddleware]);

export default betslipStore;



// WEBPACK FOOTER //
// ./src/stores/betslipStore.js